import { render, staticRenderFns } from "./ReceivableTable.vue?vue&type=template&id=209f71a4&"
import script from "./ReceivableTable.vue?vue&type=script&lang=js&"
export * from "./ReceivableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports